<template>
	<div  class="thread-message tw-mb-1 tw-relative" :class="[ { 'tw-float-right tw-text-right tw-pl-6 tw-ml-auto': mine }, { 'mine': mine }, {'new':message.new}]" >
		<div v-if="caret && !mine" class="caret-up"></div>

			<div class="tw-flex tw-items-center relative">
				<div v-if="mine && !message.deleted_at" class="tools tw-opacity-0 tw-flex tw-flex-col tw-mr-3 tw-absolute" >
					<!-- <div class="tw-mb-3 tw-cursor-pointer">
						<i class="far fa-pencil"></i>
					</div> -->
					<div class="tw-cursor-pointer" @click="showDeleteModal(message.id)">
						<i class="far fa-trash-alt"></i>
					</div>
				</div>
				<div class="tw-p-3 tw-rounded tw-relative tw-flex tw-items-center" :class="[ { 'messsage-mine': mine }, { 'tw-bg-gray-0 ': !mine }, ]" >
                   <p v-if="message.deleted_at" class="qs-400 tw-mb-1 messageBody italic" :class="[{ 'message-mine': mine },{ 'tw-text-black': !mine },]">
                        {{ translations['messages.deleted'] }}
                    </p>
					<component v-else :is="messageType" :message="message" :body="messageContent" :mine="mine"></component>
					
					<p class="qs-400 time tw-ml-2 tw-mb-0 tw-text-gray-600 tw-self-end" :class="[ { ' tw-text-left': mine }, { ' tw-text-right': !mine }, ]" >
						{{ sendTime }}
					</p>
				</div>
				<div v-if="mine" class="message-status tw-rounded-full tw-bg-white tw-w-6 tw-h-6 tw-absolute tw-right-1 tw-bottom-0 tw--mb-3 tw-z-1">
					<div class="receipt relative tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full tw-text-blue-600">
						<i class="fal" :class="receiptIcon"></i>
					</div>
				</div>
			</div>

		<div v-if="caret && mine" class="caret-down"></div>
	</div>
</template>

<script>
import MessageImage from './messageTypes/MessageImage.vue';
import MessageText from './messageTypes/MessageText.vue';
import MessageFile from './messageTypes/MessageFile.vue';
import Global from '../../mixins/Global.js';

export default {
	name: 'ThreadMessage',

	props: ['message', 'caret', 'thread', 'participantsInChat'],

	mixins: [Global],

	components: { 
		'message-text': MessageText , 
		'message-image': MessageImage,  
		'message-file': MessageFile 
	},

	methods: {
		showDeleteModal(id) {
			this.$emit('deleteMessage', id);
		},
	},

	computed: {
		messageContent() {

			let hrefRegex = /(<a href="([^"]+)"([^<]+))/g;
			let urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig; //possibly improved one (made for flutter package): /(\b(?:(?:(?:https?|ftp|file):\/\/)|(?:wwww?\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
			let urlExcludes = [];
			let content = '';

			//find all <a hrefs>, paste their src into urlExcludes
			content = this.message.body.replace(hrefRegex, function () {
				urlExcludes.push(Array.prototype.slice.call(arguments)[2]);
				return Array.prototype.slice.call(arguments)[1];
			});

			return content.replace(urlRegex, function (url) {
				// linkify links if the URL is not found by the previous regexes
				// and if we're displaying an excerpt which is shorter than the full content
				// and the link isnt broken by just displaying an excerpt (which results in https://goo instead of https://google.com)
				if(!urlExcludes.includes(url) && url.indexOf('https://media.tenor.com') === -1) {
					if(url.replace('http://','').replace('https://','').split('/')[0] !== location.href.replace('http://','').replace('https://','').split('/')[0]) {
						return '<a class="secondary-c" target="_blank" href="' + url + '">' + url + '</a>';
					} else {
						return '<a class="secondary-c" href="' + url + '">' + url + '</a>';
					}
				} else {
					return url;
				}
			});
		},

		messageRead() {
			if (this.thread !== null) {
				if (this.participantsInChat.length > 0) {
					return true;
				}
				const last_read = this.thread.partners.filter(
					(partner) => user.id !== partner.id
				)[0].last_read;

				if (new Date(this.message.created_at) < new Date(last_read)) {
					return true;
				}

				return false;
			}
			return false;
		},

		receiptIcon() {
			if(this.message.not_send) {
				return 'fa-clock';
			}
			if(this.messageRead) {
				return 'fa-check-double';
			}
			return 'fa-check';
		},

		mine() {
			return user.id === this.message.user_id;
		},

		sendTime() {
			const d = new Date(this.message.created_at);
			const m = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
			return d.getHours() + ':' + m;
		},

		messageType() {
			if(this.message.attachments.length === 0) {
				return 'message-text';
			}
			if(this.message.attachments.length > 0) {
				switch(this.message.attachments[0].filetype) {
				case 'image/png':
				case 'image/jpg':
				case 'image/jpeg':
					return 'message-image';
				case 'application/pdf':
				default:
					return 'message-file';
				}
			}
			return false;
		}
	},
	
	mounted() {
		// used for managing 'incoming' message animation
		// only fired when message.new is true
		if(this.message.new === true) {
			setTimeout(() => {
				Message.update({
					where: this.message.id,
					data(message) {
						message.new = false;
					}
				});
			}, 400);
		}
	},
};
</script>

<style lang="scss" scoped>
$light-blue: #d3eafd;

h2 {
	@apply tw-mb-1;
}

.thread-message {
	@screen lg {
		max-width: 75%;
	}
	@screen xl {
		max-width: 50%;
	}

	.receipt {
		i {
			padding-top:.25rem;

			// firefox hack
			@-moz-document url-prefix() {
				padding-top:0rem !important;
			}
		}
	}

	.tools {
		transition: all 0.2s ease-in-out;
		transform: translateX(10px);
	}

	.messsage-mine {
		background-color: $light-blue;
		color: #1a1301;
	}

	&:hover {
		.tools {
			opacity: 100%;
			transform: translateX(-20px);
		}
	}

	.message-body {
		margin-bottom: 5px;

	}

	.message-status {
		box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.24);
	}
}
.caret-down {
	position: absolute;
	bottom: -12px;
	right: 30px;
	width: 0;
	height: 0;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-top: 12px solid $light-blue;
}

.caret-up {
	position: absolute;
	top: -12px;
	left: 12px;
	width: 0;
	height: 0;
	border-left: 7px solid transparent;
	border-right: 7px solid transparent;
	border-bottom: 12px solid #f7f7f7;
}

.time {
	font-size: 11px;
}
</style>
